import { Link } from "react-router-dom";
import { brand, characterStats } from "@/mocks/siteData";
import { images } from "@/mocks/images";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="黄昏时分的乡下杂货店，暖黄的灯光从木质店门透出"
          title="洞洞杂货铺 店铺氛围插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/80" />
      </div>

      <div className="relative mx-auto flex w-full min-h-[540px] max-w-6xl flex-col items-center justify-center px-4 py-20 text-center md:min-h-[620px] md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-bold tracking-wide text-background-50 backdrop-blur">
          <i className="ri-sparkling-2-line" />
          {brand.genre.join(" · ")}
        </span>

        <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          洞洞杂货铺
        </h1>
        <p className="mt-3 font-heading text-lg font-bold text-secondary-300 md:text-2xl">
          {brand.slogan}
        </p>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          {brand.description}
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/characters"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            认识主要人物
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/settings"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 ring-1 ring-inset ring-background-50/40 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            查看店铺设定
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4">
          {characterStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50/10 px-3 py-3 backdrop-blur"
            >
              <dt className="text-[11px] text-background-100/80">{s.label}</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-background-50">
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}